import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ErrorHandlerService } from './error-handler.service';
import { AppConfigService } from './app-config.service';
import { ProcessingQueueRequest } from '../models/processing-queue-request.model';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ProcessingQueueService {

  constructor(private http: HttpClient, private errorHandler: ErrorHandlerService, private appConfigService: AppConfigService) { }

  addIncomingFunction(step: ProcessingQueueRequest): Observable<boolean> {
    return this.http.post<boolean>(`${this.appConfigService.getConfig().webApi}/api2/ProcessingQueue/IncomingSteps`, step)
      .pipe(catchError(this.errorHandler.handleError<boolean>(`add incoming step`)));
  }

  addMultiProcessingStep(step): Observable<any> {
    return this.http.post<any>(`${this.appConfigService.getConfig().webApi}/api2/ProcessingQueue/MultiProcessingSteps`, step)
      .pipe(catchError(this.errorHandler.handleError<any>(`add multi-processing step`)));
  }

}
